import { toast } from 'react-toastify';

export const errorResponseNotify = (error) => {
  console.error(
    'errorResponseNotify: ',
    error?.response ? error.response : error,
  );
  let message = error.response?.data?.detail;
  if (error.response?.data?.length) {
    const errors = error.response.data;
    message = errors[0];
  }
  if (!message) {
    message = error.response?.data?.message;
  }
  if (!message) {
    message = error?.data?.message;
  }
  if (!message) {
    message = error?.data?.[0];
  }
  if (Array.isArray(message)) {
    message.forEach((msg) => {
      toast.error(msg);
    });
  } else {
    toast.error(message);
  }
  return message;
};

export const errorNotify = (error) => {
  console.error(error);
  const errorMessage = error.message || error.toString();
  toast.error(errorMessage);
};
